import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { take, map } from 'rxjs/operators';
import { RcService } from '../services/rc.service';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class IsRmsUserGuard implements CanActivate {
  constructor(
    private readonly router: Router,
    private readonly rcService: RcService,
    private readonly authService: AuthService,
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.authService.currentUser$.pipe(
      take(1),
      map(userData => {
        const isRMSUser = userData?.IsRmsUser;
        const rmsUrl = userData?.RMSUrl;

        if (isRMSUser && rmsUrl) {
          // Clear user data before redirecting
          this.authService.clearUserData();
          // Redirect to external RMS URL if IsRmsUser is true
          globalThis.location.href = rmsUrl;
          return false; // Prevent further route activation
        } else if (isRMSUser === false || isRMSUser === undefined) {
          // Optional tenant handling
          const tenant = this.rcService.getTenant();
          if (tenant) {
            this.router.navigate([`/${tenant}`]);
            return false; // Prevent further route activation
          } else {
            return true; // Allow route activation if no tenant is provided
          }
        }

        return true; // Allow route activation in other cases
      })
    );
  }
}
